<isav-advanced-search
    *ngIf="searchState | async as searchState"
    [state]="searchState"
    viewModes="NoTimeline"
>
    <isav-advanced-search-filters [isavRestrictTaxonomies]="apiParams">
        <form [formGroup]="filters" (ngSubmit)="search()">
            <div class="field">
                <label for="extractTextField">Text</label>
                <div class="control is-fullwidth">
                    <input
                        id="extractTextField"
                        type="text"
                        class="input"
                        formControlName="text"
                        placeholder="Type text to search for infrastructure"
                        aria-label="Type text to search for infrastructure"
                        data-testid="textinput"
                    />
                </div>
            </div>

            <div class="field">
                <label for="selectInfrastructureType">Select infrastructure type</label>
                <div class="control">
                    <isav-type-taxonomy-select
                        [id]="'selectInfrastructureType'"
                        formControlName="type"
                        placeholder="Select infrastructure type"
                        [multiple]="true"
                        [dropdownInBody]="true"
                    ></isav-type-taxonomy-select>
                </div>
            </div>

            <div class="field">
                <label for="selectOrganisation">Select organisation</label>
                <div class="control">
                    <isav-taxonomy-select
                        [id]="'selectOrganisation'"
                        formControlName="organisation"
                        taxonomy="Organisation"
                        placeholder="Select organisation"
                        [dropdownInBody]="true"
                    ></isav-taxonomy-select>
                </div>
            </div>

            <div class="field">
                <label for="selectCountry">Select country</label>
                <div class="control">
                    <isav-taxonomy-select
                        [id]="'selectCountry'"
                        formControlName="country"
                        taxonomy="Country"
                        placeholder="Select country"
                        [dropdownInBody]="true"
                    ></isav-taxonomy-select>
                </div>
            </div>

            <div class="field">
                <label for="selectRegion">Select region</label>
                <div class="control">
                    <isav-taxonomy-select
                        [id]="'selectRegion'"
                        formControlName="region"
                        taxonomy="Region"
                        placeholder="Select region"
                        [dropdownInBody]="true"
                    ></isav-taxonomy-select>
                </div>
            </div>

            <div class="field">
                <label for="selectSource">Select source</label>
                <div class="control">
                    <isav-select
                        id="selectSource"
                        formControlName="source"
                        placeholder="Select source"
                    >
                        <isav-option [value]="'isav'">Isaaffik.org</isav-option>
                        <isav-option [value]="'sios'">Sios</isav-option>
                    </isav-select>
                </div>
            </div>

            <div class="field">
                <div class="control">
                    <button isavBtn color="success" type="submit" class="is-fullwidth">
                        Search
                    </button>
                </div>
            </div>
            <div class="field">
                <div class="control has-text-centered has-text-white">
                    <button
                        isavBtn
                        color="transparent"
                        type="button"
                        (click)="resetFilters()"
                        data-testid="resetbtn"
                    >
                        Reset
                    </button>
                </div>
            </div>
        </form>
    </isav-advanced-search-filters>

    <isav-advanced-search-title>Infrastructure</isav-advanced-search-title>

    <table
        *isavAdvancedSearchListView
        isav-table
        [data]="searchState.results.member"
        class="is-fullwidth"
    >
        <ng-container isavColumnDef="name">
            <th isav-header-cell isav-sort-header-cell="name" *isavHeaderCellDef>Name</th>
            <td isav-cell *isavCellDef="let row">
                <a
                    [routerLink]="row.name | isavViewLink : 'infrastructures'"
                    [queryParams]="{ iri: row['@id'] }"
                >
                    {{ row.name }}
                </a>
            </td>
        </ng-container>

        <ng-container isavColumnDef="location">
            <th isav-header-cell *isavHeaderCellDef>Location</th>
            <td isav-cell *isavCellDef="let row">{{ row.coordinates?.name }}</td>
        </ng-container>

        <ng-container isavColumnDef="coordinates">
            <th isav-header-cell isav-sort-header-cell="coordinates.latitude" *isavHeaderCellDef>
                Coordinates
            </th>
            <td isav-cell *isavCellDef="let row">{{ row.coordinates | isavGeoCoordinates }}</td>
        </ng-container>

        <ng-container isavColumnDef="type">
            <th isav-header-cell isav-sort-header-cell="types.name" *isavHeaderCellDef>Types</th>
            <td isav-cell *isavCellDef="let row">
                <isav-taxonomies-names [iris]="row.types"></isav-taxonomies-names>
            </td>
        </ng-container>

        <tr isav-header-row *isavHeaderRowDef></tr>
        <tr
            isav-row
            *isavRowDef="let row; columns: ['name', 'type', 'location', 'coordinates']"
        ></tr>
    </table>

    <isav-map [showTypeSelect]="true" *isavAdvancedSearchMapView>
        <isav-map-location-search-highlight></isav-map-location-search-highlight>
        <isav-map-markers-creation></isav-map-markers-creation>
        <isav-map-markers-display></isav-map-markers-display>
        <isav-map-clustered-vector-layer>
            <isav-map-marker
                *ngFor="let infrastructure of searchState.results.member"
                [coordinate]="[ infrastructure.coordinates.longitude, infrastructure.coordinates.latitude ]"
                [color]="infrastructure.types | infrastructureMarkerColor | async"
            >
                <a
                    *isavMapOverlayContent
                    [routerLink]="infrastructure.name | isavViewLink : 'infrastructures'"
                    [queryParams]="{ iri: infrastructure['@id'] }"
                    class="is-block"
                >
                    {{ infrastructure.name }}
                </a>
            </isav-map-marker>
        </isav-map-clustered-vector-layer>
    </isav-map>

    <ng-container *isavAdvancedSearchCardView>
        <div class="columns is-multiline">
            <isav-landing-card
                *ngFor="let infrastructure of searchState.results.member"
                [image]="infrastructure.image"
            >
                <ng-container isavLandingCardCaption>
                    Types:&nbsp;
                    <isav-taxonomies-names [iris]="infrastructure.types"></isav-taxonomies-names>
                </ng-container>
                <a
                    isavLandingCardHeading
                    [routerLink]="infrastructure.name | isavViewLink : 'infrastructures'"
                    [queryParams]="{ iri: infrastructure['@id'] }"
                >
                    {{ infrastructure.name }}
                </a>
                <p isavLandingCardFooter>
                    <strong>Location:&nbsp;</strong><br />
                    {{infrastructure.coordinates | isavGeoLocation}}
                </p>
            </isav-landing-card>
        </div>
    </ng-container>
</isav-advanced-search>
